export const TEXTS = {
    TOGGLE_FAILED_TEXT: "Action could not be completed. Try again!",
    YOU_CAN_USE_EITHER_SWIGGY_MONEY_OR_REWARDS: "You can use either Swiggy Money or rewards",
    YAY_XX_SAVED_WITH_YY_REWARDS: "Yay! ₹{0} more saved with {1} rewards!",
};
export const TIME_INTERVALS = {
    SPLITPAY_CROUTON_DISPLAY_TIME: 3000,
};

export const ICONS = {
    TOGGLE_ERROR: "Info_Icon_Filled_Red_wf4xdh.png",
    INFO_WHITE_ICON: "portal/m/info_white.png",
    SPARKLE_WHITE_ICON: "portal/m/sparkle_white.png",
};
